import { createTheme } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const themeBW: Theme = createTheme({
	typography: {
		fontFamily: 'Poppins, sans-serif',
	},
	palette: {
		primary: {
			main: '#313131',
		},
		secondary: {
			main: '#505050',
		},
		rating: {
			healthy: {
				aaa: '#d5d5d5',
				aa: '#d5d5d5',
				a: '#d5d5d5',
				bgc: '#f5f5f5',
			},
			balanced: {
				bbb: '#c4c4c4',
				bb: '#c4c4c4',
				b: '#c4c4c4',
				bgc: '#e8e8e8',
			},
			poor: {
				ccc: '#ababab',
				cc: '#ababab',
				c: '#ababab',
				bgc: '#dadada',
			},
			problematic: {
				d: '#9f9f9f',
				bgc: '#d2d2d2',
			},
		},
		gender: {
			male: '#919191',
			female: '#676767',
			other: '#4f4f4f',
		},
		race: {
			middleEastern: '#919191',
			hispanic: '#676767',
			black: '#4f4f4f',
			asian: '#3d3d3d',
			caucasian: '#2f2f2f',
			indigenous: '#282828',
		},
		custom: {
			appBackground: '#f5f5f5',
			light: '#eaeaea',
			mainBorder: '#d5d5d5',
			mainPale: '#e5e5e5',
			mainLight: '#cecece',
			mainDark: '#969696',
			barIndicator: {
				primary: '#424242',
				secondary: '#656565',
			},
		},
		status: {
			good: '#e8e8e8',
			bad: '#b9b9b9',
			empty: '#ababab',
		},
	},
	shadows: [
		'none',
		'0px 0px 20px 1px rgba(0,0,0,0.1)',
		'0px 0px 20px 2px rgba(0,0,0,0.2)',
		'0px 0px 20px 3px rgba(0,0,0,0.2)',
		'0px 0px 20px 4px rgba(0,0,0,0.2)',
		'0px 0px 20px 5px rgba(0,0,0,0.2)',
		'0px 0px 20px 6px rgba(0,0,0,0.2)',
		'0px 0px 20px 7px rgba(0,0,0,0.2)',
		'0px 0px 20px 8px rgba(0,0,0,0.2)',
		'0px 0px 20px 9px rgba(0,0,0,0.2)',
		'0px 0px 20px 10px rgba(0,0,0,0.2)',
		'0px 0px 20px 11px rgba(0,0,0,0.2)',
		'0px 0px 20px 12px rgba(0,0,0,0.2)',
		'0px 0px 20px 13px rgba(0,0,0,0.2)',
		'0px 0px 20px 14px rgba(0,0,0,0.2)',
		'0px 0px 20px 15px rgba(0,0,0,0.2)',
		'0px 0px 20px 16px rgba(0,0,0,0.2)',
		'0px 0px 20px 17px rgba(0,0,0,0.2)',
		'0px 0px 20px 18px rgba(0,0,0,0.2)',
		'0px 0px 20px 19px rgba(0,0,0,0.2)',
		'0px 0px 20px 20px rgba(0,0,0,0.2)',
		'0px 0px 20px 21px rgba(0,0,0,0.2)',
		'0px 0px 20px 22px rgba(0,0,0,0.2)',
		'0px 0px 20px 23px rgba(0,0,0,0.2)',
		'0px 0px 20px 24px rgba(0,0,0,0.2)',
	],
	// overrides: {
	// 	MuiTooltip: {
	// 		tooltip: {
	// 			fontSize: '.8rem',
	// 			padding: '0.7rem 1rem',
	// 			backgroundColor: '#efefef',
	// 			color: '#212121',
	// 		},
	// 	},
	// },
});
